import React from 'react';
import { ScrollAnimation } from './ScrollAnimation';
import { useTranslation } from '../i18n/LanguageContext';

interface ProfessorTipProps {
  tipText: React.ReactNode;
  title?: string;
}

export const ProfessorTip: React.FC<ProfessorTipProps> = ({
  tipText,
  title,
}) => {
  const { t } = useTranslation();

  return (
    <ScrollAnimation animation="slideInUp" delay={200} as="section">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 my-12 md:my-16">
        <div className="max-w-3xl mx-auto bg-brand-secondary/50 border-l-4 border-brand-accent rounded-r-lg p-6 sm:p-8 shadow-2xl transition-all duration-300 hover:shadow-brand-accent/20">
          <div className="flex items-center mb-4">
            <img
              src="https://nikolasyuri.com.br/wp/wp-content/uploads/2025/06/Nikolas-600x800-1.jpg"
              alt={`${t('tips.photoAlt')} ${t('instructorName')}`}
              className="w-14 h-14 rounded-full object-cover mr-4 border-2 border-brand-accent/70"
            />
            <h4 className="text-xl font-serif font-semibold text-brand-light">{title || t('tips.tip1Title')}</h4>
          </div>
          <blockquote className="border-none p-0 m-0">
            <p className="text-brand-text italic text-base sm:text-lg">
              "{tipText}"
            </p>
          </blockquote>
        </div>
      </div>
    </ScrollAnimation>
  );
};